var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-checklist-block__content-wrapper" }, [
    _c("div", { staticClass: "c-checklist-progress-bar" }, [
      _c(
        "div",
        {
          staticClass: "c-checklist-progress-bar__circle",
          style: _vm.circleAnimation
        },
        [
          _c("div", { staticClass: "c-checklist-progress-bar__value" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.getCurrentCheckedCount) +
                "/" +
                _vm._s(_vm.items.totalChekedCount) +
                "\n\t\t\t\t"
            ),
            _c("div", { staticClass: "c-checklist-progress-bar__text" }, [
              _vm._v("Avklarat")
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-checklist-block-item-wrapper" },
      [
        _vm._t(
          "default",
          _vm._l(_vm.items, function(item) {
            return _c("VChecklistBlockItem", {
              key: item.id,
              attrs: {
                id: item.id,
                title: item.title,
                description: item.description,
                "link-url": item.linkUrl,
                "link-text": item.linkText
              }
            })
          })
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }